import React from 'react';
import { Card, Skeleton, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { AuthLayout } from '../components/AuthLayout';
import { NS } from '../i18n';

/** antd controlHeight for size="large" inputs and buttons in the auth forms. */
const CONTROL_STYLE: React.CSSProperties = { width: '100%', height: 40 };

/**
 * Loading state for the signed-out screens that share AuthLayout (login,
 * recover account): the same layout — brand panel, footer, language picker —
 * with a placeholder card where the form goes, so nothing jumps when the real
 * form replaces it. Used as the routes' Suspense fallback and by RouteSkeleton.
 */
export function AuthPageSkeleton(): React.ReactElement {
  const { t } = useTranslation(NS);

  return (
    <AuthLayout>
      <Card
        className="sign-in-card-container"
        aria-busy="true"
        aria-label={t('layout.loadingAria')}
      >
        <Space direction="vertical" size={24} style={{ width: '100%' }}>
          <Skeleton.Input active style={{ width: 250, maxWidth: '100%', height: 32 }} />
          <Skeleton.Input active block style={CONTROL_STYLE} />
          <Skeleton.Input active block style={CONTROL_STYLE} />
          <Skeleton.Button active block style={CONTROL_STYLE} />
        </Space>
      </Card>
    </AuthLayout>
  );
}
